import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export default function LoadingSpinner() {
  return (
    <div style={{ display: "flex", justifyContent: "center", paddingTop: "110px" }}>
      <Spin
        spinning
        size="large"
        indicator={<LoadingOutlined style={{ fontSize: 64, color: "#E5BE54" }} spin />}
      />
    </div>
  );
}
